import { NgbAlertModule, NgbCarouselModule, NgbToastModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
export const SHARED_NG_BOOTSTRAP = [
    NgbCarouselModule,
    NgbAlertModule,
    NgbToastModule,
    NgbModule
];